import React, { forwardRef, useState } from 'react';
import { Pressable, Platform, StyleSheet } from 'react-native';
import Icon from '@/components/Icon';

// Shared presentation; routing, permissions and onboarding belong to the host.
export default forwardRef(function NavigationRailItem({ label, icon, active, colors, onPress, keyboardFocusVisible, ...props }, ref) {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  return <Pressable ref={ref} accessibilityRole="button" accessibilityLabel={label}
    accessibilityState={{ selected: !!active }} onPress={onPress}
    onHoverIn={() => setHovered(true)} onHoverOut={() => setHovered(false)}
    onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
    {...(Platform.OS === 'windows' && { enableFocusRing: false })}
    {...props} style={[styles.button, (active || hovered || (focused && Platform.OS !== 'windows')) && { backgroundColor: colors.solid_color_secondary },
      Platform.OS === 'windows' && { borderWidth: 1, borderColor: focused && keyboardFocusVisible ? colors.text_color_primary : 'transparent' }]}>
    <Icon name={icon} size={21} color={active ? colors.text_color_primary : colors.text_color_secondary} />
  </Pressable>;
});
const styles = StyleSheet.create({
  button: { width: 44, height: 44, alignSelf: 'center', borderRadius: 12, alignItems: 'center', justifyContent: 'center',
    ...(Platform.OS === 'web' && { cursor: 'pointer' }) },
});
